export default __webpack_public_path__ + "static/media/screen10.e0a992e6.png";